import Utility from '../../util/utilityfunctions';
import {jsonDocumentPatchOperations} from '../../util/uiconstants';

export const patchGeneratorPayload = (payload) => {
	const properties = Object.keys(payload);
	let data = [];
	properties.forEach((property) => {
		switch (property) {
			case 'rationale':
				data.push(
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'Rationale', payload.rationale),
					Utility.getJsonPatchDocumentElement(
						jsonDocumentPatchOperations.test,
						'ConcurrencyToken',
						payload.concurrencyToken
					)
				);
				break;
			case 'isDeleted':
				data.push(
					Utility.getJsonPatchDocumentElement(jsonDocumentPatchOperations.replace, 'IsDeleted', payload.isDeleted)
				);
				break;
			case 'groupRiskStatusId':
				data.push(
					Utility.getJsonPatchDocumentElement(
						jsonDocumentPatchOperations.replace,
						'GroupRiskStatusId',
						payload.groupRiskStatusId
					)
				);
				break;
			case 'relatedComponentAccounts':
				data.push(
					Utility.getJsonPatchDocumentElement(
						jsonDocumentPatchOperations.replace,
						'relatedComponentAccounts',
						payload.relatedComponentAccounts
					)
				);
				break;
			default:
				break;
		}
	});
	return data;
};
